import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import "./Playbooks.css";
import { FaLightbulb, FaTasks, FaChartLine, FaUsers, FaClipboardList, FaShieldAlt, FaCogs } from "react-icons/fa";

const Playbooks = ({ context, onApply, isOpen = true, onClose }) => {
  const { t } = useTranslation();

  // Modal overlay and container
  if (!isOpen) return null;

  const playbooks = [
    {
      id: 1,
      title: t('playbooks.scenarios3Amigos.title'),
      description: t('playbooks.scenarios3Amigos.description'),
      category: "collaboration",
      whyFollow: t('playbooks.scenarios3Amigos.whyFollow'),
      howToFollow: [
        t('playbooks.scenarios3Amigos.howToFollow.step1'),
        t('playbooks.scenarios3Amigos.howToFollow.step2'),
        t('playbooks.scenarios3Amigos.howToFollow.step3'),
        t('playbooks.scenarios3Amigos.howToFollow.step4')
      ],
      applicableTo: ["tests"],
    },
    {
      id: 2,
      title: t('playbooks.optimizeRelations.title'),
      description: t('playbooks.optimizeRelations.description'),
      category: "architecture",
      whyFollow: t('playbooks.optimizeRelations.whyFollow'),
      howToFollow: [
        t('playbooks.optimizeRelations.howToFollow.step1'),
        t('playbooks.optimizeRelations.howToFollow.step2'),
        t('playbooks.optimizeRelations.howToFollow.step3'),
        t('playbooks.optimizeRelations.howToFollow.step4')
      ],
      applicableTo: ["analysis"],
    },
    {
      id: 3,
      title: t('playbooks.reinforcePermissions.title'),
      description: t('playbooks.reinforcePermissions.description'),
      category: "security",
      whyFollow: t('playbooks.reinforcePermissions.whyFollow'),
      howToFollow: [
        t('playbooks.reinforcePermissions.howToFollow.step1'),
        t('playbooks.reinforcePermissions.howToFollow.step2'),
        t('playbooks.reinforcePermissions.howToFollow.step3'),
        t('playbooks.reinforcePermissions.howToFollow.step4')
      ],
      applicableTo: ["security"],
    },
    {
      id: 4,
      title: t('playbooks.analyzeDependencies.title'),
      description: t('playbooks.analyzeDependencies.description'),
      category: "risk",
      whyFollow: t('playbooks.analyzeDependencies.whyFollow'),
      howToFollow: [
        t('playbooks.analyzeDependencies.howToFollow.step1'),
        t('playbooks.analyzeDependencies.howToFollow.step2'),
        t('playbooks.analyzeDependencies.howToFollow.step3'),
        t('playbooks.analyzeDependencies.howToFollow.step4')
      ],
      applicableTo: ["analysis", "security"],
    },
    {
      id: 5,
      title: t('playbooks.improveLimitCases.title'),
      description: t('playbooks.improveLimitCases.description'),
      category: "testing",
      whyFollow: t('playbooks.improveLimitCases.whyFollow'),
      howToFollow: [
        t('playbooks.improveLimitCases.howToFollow.step1'),
        t('playbooks.improveLimitCases.howToFollow.step2'),
        t('playbooks.improveLimitCases.howToFollow.step3'),
        t('playbooks.improveLimitCases.howToFollow.step4')
      ],
      applicableTo: ["tests"],
    },
    {
      id: 6,
      title: t('playbooks.adoptKaizen.title'),
      description: t('playbooks.adoptKaizen.description'),
      category: "continuous-improvement",
      whyFollow: t('playbooks.adoptKaizen.whyFollow'),
      howToFollow: [
        t('playbooks.adoptKaizen.howToFollow.step1'),
        t('playbooks.adoptKaizen.howToFollow.step2'),
        t('playbooks.adoptKaizen.howToFollow.step3')
      ],
      applicableTo: ["general"],
    },
    {
      id: 7,
      title: t('playbooks.prioritizeMoSCoW.title'),
      description: t('playbooks.prioritizeMoSCoW.description'),
      category: "prioritization",
      whyFollow: t('playbooks.prioritizeMoSCoW.whyFollow'),
      howToFollow: [
        t('playbooks.prioritizeMoSCoW.howToFollow.step1'),
        t('playbooks.prioritizeMoSCoW.howToFollow.step2'),
        t('playbooks.prioritizeMoSCoW.howToFollow.step3')
      ],
      applicableTo: ["general", "analysis"],
    },
    {
      id: 8,
      title: t('playbooks.valueStreamMapping.title'),
      description: t('playbooks.valueStreamMapping.description'),
      category: "process",
      whyFollow: t('playbooks.valueStreamMapping.whyFollow'),
      howToFollow: [
        t('playbooks.valueStreamMapping.howToFollow.step1'),
        t('playbooks.valueStreamMapping.howToFollow.step2'),
        t('playbooks.valueStreamMapping.howToFollow.step3')
      ],
      applicableTo: ["general", "analysis"],
    },
    {
      id: 9,
      title: t('playbooks.qualityMetrics.title'),
      description: t('playbooks.qualityMetrics.description'),
      category: "metrics",
      whyFollow: t('playbooks.qualityMetrics.whyFollow'),
      howToFollow: [
        t('playbooks.qualityMetrics.howToFollow.step1'),
        t('playbooks.qualityMetrics.howToFollow.step2'),
        t('playbooks.qualityMetrics.howToFollow.step3')
      ],
      applicableTo: ["general", "tests", "analysis"],
    },
    {
      id: 10,
      title: t('playbooks.standardizeDocument.title'),
      description: t('playbooks.standardizeDocument.description'),
      category: "governance",
      whyFollow: t('playbooks.standardizeDocument.whyFollow'),
      howToFollow: [
        t('playbooks.standardizeDocument.howToFollow.step1'),
        t('playbooks.standardizeDocument.howToFollow.step2'),
        t('playbooks.standardizeDocument.howToFollow.step3')
      ],
      applicableTo: ["general", "security"],
    },
  ];

  const filteredPlaybooks = playbooks; // Display all playbooks without filtering

  return (
    <div className="playbooks-overlay">
      <div className={`playbooks-modal`}>
        <div className="playbooks-modal-header">
          <span className="playbooks-modal-icon">📚</span>
          <h2>{t('playbooks.title')}</h2>
          <button className="playbooks-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="playbooks-modal-desc">{t('playbooks:guideDesc')}</div>
        
        {/* Header avec compteur de playbooks */}
        <div className="playbooks-collection-header">
          <div className="playbooks-count">
            <span className="playbooks-count-icon">📚</span>
            <span>{t('playbooks.available', { defaultValue: 'Fiches disponibles' })}</span>
            <span className="playbooks-count-number">{filteredPlaybooks.length}</span>
          </div>
          <div className="playbooks-layout-info">
            <span className="playbooks-layout-info-icon">⚡</span>
            <span>{t('playbooks.layoutInfo', { defaultValue: 'Affichage en colonnes adaptatif' })}</span>
          </div>
        </div>
        
        <div className="playbooks-modal-grid">
          {filteredPlaybooks.length > 0 ? (
            filteredPlaybooks.map((pb, index) => (
              <PlaybookCard 
                key={pb.id} 
                playbook={pb} 
                icon={getIcon(pb.category)} 
                onApply={onApply}
              />
            ))
          ) : (
            <p>{t('playbooks.noAvailable')}</p>
          )}
        </div>
      </div>
    </div>
  );
};

const PlaybookCard = ({ playbook, icon, onApply }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const [applyStatus, setApplyStatus] = useState('idle');

  const handleToggle = () => {
    if (isExpanded) {
      // Si on ferme, simplement replier
      setTimeout(() => setIsExpanded(false), 100);
    } else {
      // Si on ouvre, expand inline
      setIsExpanded(true);
    }
  };


  const handleApply = async () => {
    setApplyStatus('working');
    const checklist = [t('playbooks.playbookLabel', { title: playbook.title }), '', t('playbooks.stepsRecommended')].concat(
      playbook.howToFollow.map((s, i) => `${i + 1}. ${s}`)
    ).join('\n');

    try {
      if (typeof onApply === 'function') {
        await onApply(playbook);
      } else if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(checklist);
        console.log(t('playbooks.checklistCopied'), checklist);
      } else {
        console.log(t('playbooks.checklistFallback'), checklist);
      }
      setApplyStatus('done');
      setTimeout(() => setApplyStatus('idle'), 2000);
    } catch (err) {
      console.error(t('playbooks.applyError'), err);
      setApplyStatus('error');
      setTimeout(() => setApplyStatus('idle'), 2000);
    }
  };

  return (
    <>
      <div className={`playbook-card pb-${playbook.category} playbook-modal-card`}> 
        
        <div className="playbook-modal-header">
          <div className="playbook-modal-icon">{icon}</div>
          <div className="playbook-modal-title">
            <h3>{playbook.title}</h3>
            <div className="playbook-modal-chip">{playbook.category.replace(/-/g, ' ')}</div>
          </div>
        </div>
        <div className="playbook-modal-desc">{playbook.description}</div>
        <div className="playbook-modal-actions">
          <button
            className="playbook-modal-toggle"
            onClick={handleToggle}
            aria-expanded={isExpanded}
            aria-controls={`playbook-details-${playbook.id}`}
          >
            {isExpanded ? t('playbooks.reduce') : t('playbooks.learnMore')}
          </button>
          <button className="playbook-modal-apply" onClick={handleApply}>
            {applyStatus === 'working' ? t('playbooks.inProgress') : applyStatus === 'done' ? t('playbooks.copied') : t('playbooks.apply')}
          </button>
        </div>
        <div
          id={`playbook-details-${playbook.id}`}
          className={`playbook-modal-details playbook-modal-details-collapsible ${isExpanded ? 'open' : ''}`}
          aria-hidden={!isExpanded}
        >
          <strong>{t('playbooks.whyFollow')}</strong>
          <p>{playbook.whyFollow}</p>
          <strong>{t('playbooks.howToFollow')}</strong>
          <ol>
            {playbook.howToFollow.map((step, index) => (
              <li key={index}>{step}</li>
            ))}
          </ol>
        </div>
      </div>
    </>
  );
};

const getIcon = (category) => {
  switch (category) {
    case 'collaboration':
      return <FaUsers className="playbook-icon" />;
    case 'architecture':
      return <FaCogs className="playbook-icon" />;
    case 'security':
      return <FaShieldAlt className="playbook-icon" />;
    case 'risk':
      return <FaChartLine className="playbook-icon" />;
    case 'testing':
      return <FaClipboardList className="playbook-icon" />;
    default:
      return <FaLightbulb className="playbook-icon" />;
  }
};

export default Playbooks;
